export default __webpack_public_path__ + "static/22-be2a042415e337cb4ab7c23a8bb9671b.jpg";